import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/tenant-profile/owner')({
  component: lazyRouteComponent(() => import('&/features/settings/organization/pages/tenant-owner-page')),
  staticData: { titleKey: 'tenantProfile' },
});
